<!-- Loader -->
<div *ngIf="isLoading" class="fixed inset-0 flex items-center justify-center z-50 backdrop-blur-sm">
  <i class="fas fa-spinner fa-spin text-6xl" style="color:#c19725;"></i>
</div>

<div *ngIf="!isLoading && orders.length > 0" class="p-4">
  <!-- Responsive grid for products -->
  <div class="grid grid-cols-1 md:grid-cols-1 gap-6">

    <!-- Loop through products -->
    <div *ngFor="let order of orders" class="bg-white rounded-2xl shadow-md p-6 hover:shadow-lg transition">

      <!-- Product Details Header -->
      <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center border-b pb-3 mb-4">
        <button
        *ngIf="
          order.request_status === 'raw_material_issue' &&
          order.status === 'issued'
        "
        (click)="requestReturn(order.id)"
        class="px-4 py-1 bg-red-600 text-white rounded hover:bg-red-700 text-sm"
        style="position: relative; z-index: 9999;"
      >
        Return
      </button>
        <div>
          <h2 class="text-lg font-semibold text-gray-800">
            {{ order.product_name }}
            <span class="text-sm text-gray-500">({{ order.product_code }})</span>
          </h2>
          <p class="text-sm text-gray-600">Total Assigned Product Quantity: {{ order.quantity }}</p>
        </div>
  <!-- History Tabs -->
<!-- <div class="overflow-x-auto overflow-y-hidden whitespace-nowrap scrollbar-hide md:overflow-x-hidden mt-4">
  <div class="min-w-max flex justify-start items-center w-[460px] lg:w-[600px]">

    <a
  [routerLink]="[
    '/kalakaar-management',
    'order',
    order.id,
    'assign-history'
  ]"
      routerLinkActive="bg-c19725 text-white font-medium outline-c19725 hover:bg-c19725 hover:text-white"
      class="ml-auto px-3 py-1.5
             border-[0.50px] border-[#D9D9D9]
             flex justify-center items-center
             text-[#898989] text-xs lg:text-sm
             rounded-md
             hover:bg-[#f6f1cb] hover:text-black">
      History
    </a>

  </div>
</div> -->


        <span class="px-3 py-1 text-xs font-medium rounded-full mt-2 sm:mt-0" [ngClass]="{
            'bg-green-100 text-green-700': order.status === 'completed',
            'bg-yellow-100 text-yellow-700': order.status === 'pending',
            'bg-red-100 text-red-700': order.status === 'rejected'
          }">
          {{ order.status | titlecase }}
        </span>
      </div>

      <!-- Raw Metals & Stones Sections -->
      <div class="grid grid-cols-1 xl:grid-cols-2 gap-6">

        <!-- ===== UNIFIED METALS TABLE ===== -->
        <div *ngIf="order.unifiedMetalDetails?.length > 0" class="space-y-2">
          <div class="flex items-center">
            <img src="/assets/images/stock/gold.png" alt="Metal Icon" class="size-6 me-2">
            <h3 class="text-md font-semibold text-gray-700">Raw Metals Summary</h3>
          </div>
          <div class="overflow-x-auto">
            <table class="min-w-full border text-sm">
              <thead class="bg-[#F2F2F2] text-444 text-xs text-center">
                <tr>
                  <th rowspan="2" class="p-3 font-medium border border-[#D9D9D9] align-middle">Code</th>
                  <th rowspan="2" class="p-3 font-medium border border-[#D9D9D9] align-middle">Name</th>
                  <th colspan="3" class="p-3 font-medium border border-[#D9D9D9]">Total Quantity</th>
                  <th colspan="3" class="p-3 font-medium border border-[#D9D9D9]">Total Weight (gm)</th>
                </tr>
                <tr>
                  <th class="p-2 font-medium border border-[#D9D9D9] bg-gray-100">Assigned</th>
                  <th class="p-2 font-medium border border-green-200 bg-green-50 text-green-800">Submitted</th>
                  <th class="p-2 font-medium border border-blue-200 bg-blue-50 text-blue-800">Available</th>
                  <th class="p-2 font-medium border border-[#D9D9D9] bg-gray-100">Assigned</th>
                  <th class="p-2 font-medium border border-green-200 bg-green-50 text-green-800">Submitted</th>
                  <th class="p-2 font-medium border border-blue-200 bg-blue-50 text-blue-800">Available</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let metal of order.unifiedMetalDetails" class="text-center">
                  <td class="p-3 border border-[#D9D9D9] font-semibold">{{ metal.code }}</td>
                  <td class="p-3 border border-[#D9D9D9]">{{ metal.artical_name }}</td>
                  <td class="p-3 border border-[#D9D9D9]">{{ metal.assigned_qty }}</td>
                  <td class="p-3 border border-green-200 text-green-700 font-medium">{{ metal.submitted_qty }}</td>
                  <td class="p-3 border border-blue-200 text-blue-700 font-medium">{{ metal.available_qty }}</td>
                  <td class="p-3 border border-[#D9D9D9]">{{ metal.assigned_weight | number:'1.2-2' }}</td>
                  <td class="p-3 border border-green-200 text-green-700 font-medium">{{ metal.submitted_weight | number:'1.2-2' }}</td>
                  <td class="p-3 border border-blue-200 text-blue-700 font-medium">{{ metal.available_weight | number:'1.2-2' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- ===== UNIFIED STONES TABLE ===== -->
        <div *ngIf="order.unifiedStoneDetails?.length > 0" class="space-y-2">
          <div class="flex items-center">
            <img src="/assets/images/stock/gold-diamond.png" alt="Stone Icon" class="size-6 me-2">
            <h3 class="text-md font-semibold text-gray-700">Raw Stones Summary</h3>
          </div>
          <div class="overflow-x-auto">
            <table class="min-w-full border text-sm">
              <thead class="bg-[#F2F2F2] text-444 text-xs text-center">
                <tr>
                  <th rowspan="2" class="p-3 font-medium border border-[#D9D9D9] align-middle">Code</th>
                  <th rowspan="2" class="p-3 font-medium border border-[#D9D9D9] align-middle">Name</th>
                  <th colspan="3" class="p-3 font-medium border border-[#D9D9D9]">Total Stone Quantity</th>
                </tr>
                <tr>
                  <th class="p-2 font-medium border border-[#D9D9D9] bg-gray-100">Assigned</th>
                  <th class="p-2 font-medium border border-green-200 bg-green-50 text-green-800">Submitted</th>
                  <th class="p-2 font-medium border border-blue-200 bg-blue-50 text-blue-800">Available</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let stone of order.unifiedStoneDetails" class="text-center">
                  <td class="p-3 border border-[#D9D9D9] font-semibold">{{ stone.code }}</td>
                  <td class="p-3 border border-[#D9D9D9]">{{ stone.stone_name }}</td>
                  <td class="p-3 border border-[#D9D9D9]">{{ stone.assigned_weight }}</td>
                  <td class="p-3 border border-green-200 text-green-700 font-medium">{{ stone.submitted_weight }}</td>
                  <td class="p-3 border border-blue-200 text-blue-700 font-medium">{{ stone.available_weight }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Empty state -->
<div *ngIf="!isLoading && (!orders || orders.length === 0)" class="text-center py-10 text-gray-500">
  No raw material data found.
</div>
